import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SleepForm from '../forms/sleep-form';
import { sleepValidationSchema } from '../schema/sleep.js';

export default function SleepNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Sleep Node Details',
        altText: 'Sleep Node',
        defaultLabel: data?.command || 'Sleep Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={SleepForm} schemaResolver={sleepValidationSchema} />
    </NodeProvider>
  );
}
